import styled from 'styled-components'

const ConversationItemTime = styled.div`
	font-size: 12px;
	color: rgb(171, 174, 190);
`

export default ConversationItemTime